<template>
	<div>
		<div class="nav naver">
			<div class="w nav-box">
				<template v-if="mch && mch.id">
					<router-link :to="{path:'/shopClassify',query:{mch_id:mch.id}}" class="nav-all" @mouseover="selectStyle(1)" @mouseout="outStyle()" :class="{hidden:1==iShow}">
						<img class="img-all" src="../../assets/images/nav_all.png" alt />
						本店全部商品
						<img class="img-xia" src="../../assets/images/nav_xia.png" alt />
						<div class="nav-po" :class="{active:1==iShow}" v-if="false">
							<div class="nav-po-item d-flex align-items-center">全部商品</div>
							<div class="nav-po-item d-flex align-items-center">苹果(iphone)</div>
							<div class="nav-po-item d-flex align-items-center">华为(huawei)</div>
							<div class="nav-po-item d-flex align-items-center">荣耀(honor)</div>
							<div class="nav-po-item d-flex align-items-center">小米(mi)</div>
							<div class="nav-po-item d-flex align-items-center">魅族(MEIZU)</div>
							<div class="nav-po-item d-flex align-items-center">诺基亚(NOKIA)</div>
						</div>
					</router-link>
				</template>
				<ul class="nav-list">
					<li v-for="(item,index) in common_info.header.list" :key="index">
						<!-- 本窗口 -->
						<template v-if="item.open_type == 0">
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url" v-text="item.title"></a>
							</template>
							<!-- 内部链接 -->
							<template>
								<router-link :to="item.page_url" v-text="item.title"></router-link>
							</template>
						</template>
						<!-- 新窗口 -->
						<template v-else>
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url" target="_blank" v-text="item.title"></a>
							</template>
							<!-- 内部链接 -->
							<template>
								<router-link :to="item.page_url" target="_blank" v-text="item.title"></router-link>
							</template>
						</template>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			mch: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				iShow: -1,
				common_info: {
					header: {
						background: {}
					}
				},
				
			};
		},
		created() {
			this.common.getCommonInfo(this);
		},
		methods: {
			selectStyle(index) {
				var _this = this;
				_this.iShow = index;
			},
			outStyle() {
				this.iShow = -1;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.nav {
		height: 40px;
		width: 100%;
		background-color: #333333;

		.nav-box {
			display: flex;
			height: 40px;
			line-height: 40px;

			.nav-all {
				display: flex;
				align-items: center;
				font-size: 16px;
				width: 140px;
				box-sizing: border-box;
				color: #fff;
				position: relative;
				overflow: hidden;

				&:hover {
					overflow: visible !important;
				}

				.nav-po {
					width: 140px;
					background-color: #333333;
					padding: 8px 0;
					box-sizing: border-box;
					position: absolute;
					left: 0;
					top: 40px;
					z-index: 999;

					.nav-po-item {
						height: 32px;
						padding: 0 14px;
						box-sizing: border-box;
						color: #fff;

						&:hover {
							background-color: #ff0e25;
						}
					}
				}

				.img-all {
					width: 14px;
					height: 12px;
					margin-right: 8px;
					vertical-align: middle;
				}

				.img-xia {
					width: 9px;
					height: 6px;
					margin-left: 4px;
					vertical-align: middle;
				}
			}

			.nav-list {
				display: flex;
				flex-wrap: wrap;
				overflow: hidden;
				flex: 1;
				li {
					margin-right: 16px;
					font-size: 16px;
					color: #fff;
					box-sizing: border-box;
					background-color: #333;
					cursor: pointer;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					a {
						display: block;
						padding: 0 12px;
						font-size: 16px;
						color: #fff;
					}

					&:hover {
						background-color: #ff0e25;
					}
				}
				li:last-child{
					margin-right: 0;
				}
			}
			.nav-list:nth-child(2){
				margin-left:48px;
			}
		}
	}
</style>
